// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__24c88","col":"Table_col__1beHN","fulfillmentStatus":"Table_fulfillmentStatus__2aaRc","emailCol":"Table_emailCol__2DoLk"};